import { useEffect } from "react";
import useAuth from "./useAuth";
import useSignOut from "./useSignOut";
import { getLastActivity } from "../utils/activityTracker";

const CHECK_INTERVAL_MS = 60 * 1000;
const IDLE_TIMEOUT_MS = 3 * 60 * 60 * 1000; // auto sign out after 3h of inactivity

const useIdleLogout = () => {
    const { auth } = useAuth();
    const signOut = useSignOut();
    const isAuthenticated = !!auth?.token && auth.token !== 'Unauthorized';

    useEffect(() => {
        if (!isAuthenticated) return;

        const interval = setInterval(() => {
            if ((Date.now() - getLastActivity()) > IDLE_TIMEOUT_MS) signOut();
        }, CHECK_INTERVAL_MS);

        return () => clearInterval(interval);
    }, [isAuthenticated]);
}

export default useIdleLogout;
